import { useSettings } from '@/context/settings-context/settings-context';

export const useServerNotificationMute = (serverId: string) => {
  const { notifications, mutedServers } = useSettings();

  const isServerMuted = mutedServers?.[serverId] === true;

  const allowNotify = notifications && !isServerMuted;

  return { allowNotify, isServerMuted };
};
